
import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'
import Popup from 'vux/src/components/popup/index.vue'

import viewRelateFlow from '@/components/browse/view-relate-flow';

export default {
name: "claim-management-view",
components: {
fileUpload,
DivSpan,
Popup,
viewRelateFlow
},
props: ['dataId','dataImg','editable'],
data() {
return {
baseDto: {},
list: [],
viewItemDto: {},
gridList: [
{icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
{icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'费用明细'},
{icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
],
confirmList: [{name:'通过',value:'pass'},{name:'不通过',value:'nopass'}],
isVisible: false,
showContent: false,
showContent2: false,
showContent3: false,
showContent4: false,
bigImg:false,
replySee:false,
confirmSee:false,
cwconfirmSee:false,
index: 1,
proStateList: [{name: '001 未处理', flag: '001'}, {name: '002 完结', flag: '002'}],
i: 1,
}
},
methods: {
changedataShow(i) {
if (this.list[i].contentShow) {
this.$set(this.list[i], 'contentShow', false);
return;
}
this.$set(this.list[i], 'contentShow', true);
},
formData(){
return this.baseDto
},
valid(){

if(this.baseDto.flowState=='reply'){
if(!this.list.every(val=>val.proState)){
this.$vux.toast.text(`请补充费用明细里的确认费用金额`);
return   false
}
if(!this.list.every(val=>val.replyDesc)){
this.$vux.toast.text(`请补充费用明细里的回复说明`);
return   false
}
return   true
}


if(this.baseDto.flowState=='confirm'){




return   true
}

if(this.baseDto.flowState=='cwconfirm'){




return   true
}

return   true;

},

toBaseDto(){
this.baseDto.claimDtList[this.i]=this.viewItemDto;
},
itemTab(index) {
this.index = index;
if(index === 3){
this.$emit('changeFlowInfo',true);
}else{
this.$emit('changeFlowInfo',false);
}
},
itemView(item,i) {
this.isVisible = !this.isVisible;
this.i=i;
this.viewItemDto = item;
},
getBaseDto() {
this.$loadingShow();
this.$get('api/claim/' + this.dataId).then((data) => {
if (data) {
this.baseDto = data;
this.list = data.claimDtList;
switch (data.flowState) {
case "reply":
this.replySee=true;
case "confirm":
this.confirmSee=true;
case "cwconfirm":
this.cwconfirmSee=true;
}
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
}

},
mounted(){
if(this.dataId){
this.getBaseDto()
}
},
watch:{
dataId(){
if(this.dataId){
this.getBaseDto()
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/claim-management/claim-management-view.vue